import { Form } from 'antd'
import styled from 'styled-components'

const StyledForm = styled(Form)`
  &.label-highlight {
    .ant-form-item {
      color: #fff;
      .ant-form-item-label > label {
        color: #a1ddff !important;
      }
    }
  }
  .ant-form-item .ant-form-item-label {
    padding: 0 0 4px;

    label {
      font-size: 12px;
      color: ${p => p.theme.form.labelColor} !important;
    }
  }
`

export default StyledForm
